export default {"src":"/_next/static/image/public/assets/icons/chart-bar.0aa4cc659723c9a9fe1d1ac5d026b863.svg","height":20,"width":20};